export default function Alert({ bgColor, message }) {
  return (
    <div className={`py-4 w-10/12 border-l-4 border-yellow-400 ${bgColor}`}>
      <div className="flex">
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            {message}
          </p>
        </div>
      </div>
    </div>
  )
}
